import React from "react";
import { useInView } from "react-intersection-observer";

// Import Card variants
import CardVariant from "./CardVariant";
import CardHorizontal from "./CardHorizontal";
import CardBenefitHorizontal from "./CardBenefitHorizontal";
import CardPrimary from "./CardPrimary";
import CardSecondary from "./CardSecondary";
import CardFeature from "./CardFeature";
import CardOverlay from "./CardOverlay";
import CardAccent from "./CardAccent";
import CardTestimonial from "./CardTestimonial";

// Standard CardComponent import
import CardStandard from "./CardStandard";

/**
 * Universal Card component that renders different card layouts based on the 'layout' prop
 * 
 * @param {string} props.layout - Determines card style: "standard", "primary", "testimonial", etc.
 * @param {string} props.title - Card title (or author name in testimonials)
 * @param {string} props.lead - Subtitle text (or author position in testimonials)
 * @param {string} props.desc - Main content HTML
 * @param {string} props.image - Image URL (used as main image or author image depending on layout)
 */
const Card = ({ 
	layout = "standard",
	...props
}) => {
	const { ref, inView } = useInView({ 
		triggerOnce: true, 
		threshold: 0 
	});
	
	// Add inView and ref to props passed to all card variants
	const cardProps = {
		ref,
		inView,
		...props
	};

	
	
	// Choose appropriate layout component
	switch (layout) {
		case "variant":
			return <CardVariant {...cardProps} />;
		case "horizontal":
			return <CardHorizontal {...cardProps} />;
		case "primary":
			return <CardPrimary {...cardProps} />;
		case "secondary":
			return <CardSecondary {...cardProps} />;
		case "feature":
			return <CardFeature {...cardProps} />;
		case "overlay":
			return <CardOverlay {...cardProps} />;
		case "accent":
			return <CardAccent {...cardProps} />;
		case "testimonial":
			return <CardTestimonial {...cardProps} />;
		case "benefit-horizontal":
			return <CardBenefitHorizontal {...cardProps} />;
		default:
			return <CardStandard {...cardProps} />;
	}
};

export default Card;
